angular.module('storefrontApp')
    .controller('bulkOrderController', ['$scope', function ($scope) {
        $scope.atLeastOneNotEmpty = function () {
            const { bulkOrder } = $scope;

            $scope.skuRowsIsEmpty = true;

            if (angular.isDefined(bulkOrder)) {
                angular.forEach(bulkOrder.skuRows, (rows) => {
                    angular.forEach(rows, (row) => {
                        if (row.length > 0) {
                            $scope.skuRowsIsEmpty = false;
                        }
                    });
                });
            }
        };
    }]);
